'use strict';

import stringSimilarity from 'string-similarity'

angular.module('docketbook').
  controller('importContactsModalController', function (addressBookService, xeroService, $scope, Upload, $q) {


    /*****************************/
    /*****  Xero Importing   *****/
    /*****************************/

    $scope.xeroContactSearchList = []
    $scope.xeroContactSearchValue = ""
    $scope.selectedContacts = []
    $scope.xeroSyncLoading = false
    $scope.selectedTabIndex = 0

    $scope.allResourceCategories = [];
    $scope.sortedResourceCategories = {};
    $scope.allUoms = [];
    $scope.sortedUoms = {};


    if ($scope.currentOrg != null) {
      xeroService.getXeroContacts(function (contacts) {
        $scope.xeroContactsList = contacts/*.map(c => Object.assign(c, c.addresses ? { selectedAddress: c.addresses[0] } : {}))*/
      }, function (err) {
        $scope.xeroContactsList = [];
      });
    }

    $scope.$parent.showImportContactsModal = function () {
      $scope.xeroContactSearchValue = ""
      $scope.xeroContactSearchList = $scope.xeroContactsList
      $scope.selectedContacts = []
      $scope.selectedTabIndex = 0
      $scope.mode = 'import';
      $scope.contactImport = { 'loading': false };
      $scope.file = null
      $("#importContactsModal").fadeIn(100)
    }

    $scope.close = function () {
      $("#importContactsModal").fadeOut(100)
    }

    $scope.selectAddress = function (contact, address) {
      contact.selectedAddress = address;
    }

    $scope.xeroContactSync = function () {
      $scope.selectedContacts = []
      $scope.xeroSyncLoading = true
      xeroService.xeroContactSync(function (taskInfo) {
        if (taskInfo.status == 'Failed') {
          $scope.alertService.presentAlert('error', "We couldn't sync your Xero Contacts", "Something went wrong when we tried to sync your Xero Contacts. Please try again or contact support if this error persists.")
          $scope.xeroSyncLoading = false
        } else {

          xeroService.getXeroContacts(function (contacts) {
            $scope.xeroContactsList = contacts/*.map(c => Object.assign(c, c.addresses ? { selectedAddress: c.addresses[0] } : {}))*/
            $scope.xeroContactSearchList = $scope.xeroContactsList

            $scope.xeroSyncLoading = false
            $scope.showContactSyncSuccess = true
          }, function (err) {
            $scope.xeroContactsList = [];
            $scope.xeroSyncLoading = false
            $scope.showContactSyncSuccess = true
          });
        }
      })
    }

    $scope.getTableStyle = function () {
      if ($scope.xeroSyncLoading) {
        return { opacity: 0.5 }
      } else {
        return {}
      }
    }

    $scope.searchXeroContactChange = function (searchValue) {
      if (searchValue == "") {
        $scope.xeroContactSearchList = $scope.xeroContactsList;
        return;
      }
      $scope.xeroContactSearchList =
        $scope.xeroContactsList
          .filter(contact =>
            stringSimilarity.compareTwoStrings(contact.name, searchValue) > 0.5
            || contact.name.toLowerCase().indexOf(searchValue.toLowerCase()) != -1
          )
    }

    $scope.import = function () {
      $scope.importing = true


      var contacts = $scope.selectedContacts.map(contact => ({
        displayName: contact.name,
        addresses: contact.addresses,
        xeroContact: contact,
        externalIdentifiers: [{ type: 'xero', externalId: contact.externalId }],
        contactAddresses: contact.emailAddresses.map(email => ({ emailAddress: email, accessLevel: 'viewer' })),
      }))

      var errors = []

      const saveContact = () => {
        if (contacts.length == 0) {
          $scope.importing = false
          $scope.$parent.loadAddressBook()
          $("#importContactsModal").fadeOut(100)
        } else {
          const contact = contacts.pop()
          addressBookService.saveContact(contact, saveContact, err => {
            errors.push(err)
            saveContact()
          })
        }
      }
      saveContact()
    }


    /*****************************/
    /*****  File Importing   *****/
    /*****************************/

    $scope.cancelImport = function () {
      $scope.close();
      $scope.mode = 'list';
      $scope.importList = [];
    }

    const mapping = {
      'customer name': 'name',
      'email': 'email',
      'unit number': 'unitNum',
      'street number': 'streetNum',
      'street name': 'streetName',
      'suburb': 'suburb',
      'state': 'state',
      'postcode': 'postCode',
      'country': 'country'
    }

    const reverseMapping = {}

    Object.keys(mapping)
      .forEach(key => {
        reverseMapping[mapping[key]] = key
      })


    const readTableHeaders = fileData => {
      const headers =
        fileData.shift()
          .map(header => header.toLowerCase())
          .map(header => {
            var found = null
            Object.keys(mapping).forEach(key => {
              if (header.includes(key)) {
                found = mapping[key]
                return
              }
            })
            return found
          })
          .filter(x => x !== null)


      const headerMissing = str => !headers.includes(str)

      const missing = ['name', 'email'].filter(headerMissing).map(header => reverseMapping[header])

      if (missing.length > 0) {
        swal({
          title: "Oops!",
          text: `The following columns are missing from the file: ${missing.join(', ')}`,
          type: "error",
          confirmButtonText: "Ok, got it."
        });
        return null
      }

      return fileData.map(data => {
        var item = {}
        headers.forEach((header, i) => {
          item[header] = data[i]
        })
        return item
      })
    }

    $scope.importFromFile = function (fileToUpload) {
      $scope.contactImport.loading = true;

      Upload.upload({
        url: '/v1/parse',
        data: { file: fileToUpload },
        withCredentials: true
      }).then(function (resp) {
        var data = readTableHeaders(resp.data[0].data)
        if (data == null) {
          $scope.resourceImport.loading = false;
          return
        }

        $scope.parseContactsForImport(data);
      }, function (resp) {
        $scope.contactImport.loading = false;
        $scope.alertService.presentAutoAlert('readFile', resp);
      });
    }

    const containsEmptyFields = (...arr) => {
      return arr.includes(undefined) || arr.includes(null) || arr.includes('')
    }

    $scope.parseContactsForImport = function (data) {
      $scope.contactImport.loading = true;
      var contactsList = [];
      $scope.importSelected = [];

      const Geocoder = new google.maps.Geocoder()

      var errors = []

      const promises = data.map(({ name, email, unitNum, streetNum, streetName, suburb, state, postCode, country }, lineNum) => {
        return $q((resolve, reject) => {
          if ([name, email, unitNum, streetName, suburb, state, postCode, country].filter(x => x != null && x != undefined && x != '').length == 0) {
            return resolve()
          }

          if (containsEmptyFields(name/*, email*/)) {
            var missing = []
            if (containsEmptyFields(name)) {
              missing.push('customer name')
            }
            /*if (containsEmptyFields(email)) {
              missing.push('customer email')
            }*/

            errors.push(`Line ${lineNum + 2}: missing data: ${missing.join(', ')}`)
            return resolve()
          }

          var newUser = {
            displayName: name,
            contactAddresses: email ? [{ emailAddress: email, accessLevel: 'viewer' }] : [],
            tags: []
          }

          if ([streetNum, streetName, suburb, state, postCode, country].filter(x => x != undefined && x != null && x != '').length == 0 && unitNum != null) {
            Geocoder.geocode({ address: unitNum }).then(addr => {
              if (addr.results.length > 0) {
                const loc = addr.results[0]

                const getFromLoc = type => {
                  const found = loc.address_components.filter(l => l.types.includes(type))
                  if (found.length > 0) {
                    return type == 'administrative_area_level_1' ? found[0].short_name : found[0].long_name
                  } else return ''
                }

                const newAddress = {
                  country: getFromLoc('country'),
                  state: getFromLoc('administrative_area_level_1'),
                  postCode: getFromLoc('postal_code'),
                  suburb: getFromLoc('locality'),
                  streetName: getFromLoc('route'),
                  streetNum: getFromLoc('street_number'),
                  num: getFromLoc('subpremise'),
                }
                newUser.address = newAddress
                newUser.addresses = [newAddress]
                $scope.importSelected.push(newUser)
                resolve()
              } else {
                errors.push(`Line ${lineNum + 2}: Address not found.`)
                resolve()
              }

            })
          } else if (!containsEmptyFields(streetNum, streetName, suburb, state, postCode, country)) {
            const address = { num: unitNum ? '' + unitNum : undefined, streetNum: '' + streetNum, streetName, suburb, state, postCode: '' + postCode, country }
            newUser.address = address
            newUser.addresses = [address]
            $scope.importSelected.push(newUser)
            resolve()
          } else if ([unitNum, streetNum, streetName, suburb, state, postCode, country].filter(x => x != undefined && x != null && x != '').length == 0) {
            newUser.address = {}
            newUser.addresses = []
            $scope.importSelected.push(newUser)
            resolve()
          } else {
            errors.push(`Line ${lineNum + 2}: Either a full address in separate columns or as a single string in the unit number required.`)
            resolve()
          }
        })
      })

      $q.all(promises).then(() => {
        if (errors.length > 0) {
          $scope.close()
          swal({
            title: "Errors in file",
            text: errors.join('\n'),
            type: "warning",
            confirmButtonText: "Ok, got it."
          })
        } else {
          $scope.bulkImportContacts($scope.importSelected, function () {
            $scope.contactImport.loading = false;
            $scope.close();
          }, function () {
            $scope.close()
            swal({
              title: "Oops!",
              text: "Error importing contacts",
              type: "error",
              confirmButtonText: "Ok, got it."
            })
          })
        }
      })
    }



    $scope.parseContactsForImport_OLD = function (importData) {
      $scope.contactImport.loading = true;
      var contactsList = [];
      $scope.importSelected = [];

      for (var i = 0; i < importData.length; i++) {
        for (var j = 0; j < importData[i].data.length; j++) {
          var newContact = {};
          newContact.displayName = importData[i].data[j][0];
          newContact.contactAddresses = [];
          if (importData[i].data[j][1] != null) {
            newContact.contactAddresses.push({ emailAddress: importData[i].data[j][1], accessLevel: 'viewer' });
          }
          newContact.addresses = [];
          var newAddress = {};
          var requiredFound = 0;
          if (importData[i].data[j][2] != null) {
            newAddress.num = String(importData[i].data[j][2]);
          }
          if (importData[i].data[j][3] != null) {
            newAddress.streetNum = String(importData[i].data[j][3]);
            //requiredFound += 1;
          }
          if (importData[i].data[j][4] != null) {
            newAddress.streetName = importData[i].data[j][4];
            requiredFound += 1;
          }
          if (importData[i].data[j][5] != null) {
            newAddress.suburb = importData[i].data[j][5];
            requiredFound += 1;
          }
          if (importData[i].data[j][6] != null) {
            newAddress.state = importData[i].data[j][6];
            requiredFound += 1;
          }
          if (importData[i].data[j][7] != null) {
            newAddress.postCode = String(importData[i].data[j][7]);
            requiredFound += 1;
          }
          if (importData[i].data[j][8] != null) {
            newAddress.country = importData[i].data[j][8];
            requiredFound += 1;
          }

          if (requiredFound >= 5) {
            newContact.addresses.push(newAddress);
          }

          $scope.importSelected.push(newContact);
        }
      }
      $scope.bulkImportContacts($scope.importSelected, function () {
        $scope.contactImport.loading = false;
        $scope.close();
      });
    }

    $scope.bulkImportContacts = function (importList, cb) {
      addressBookService.bulkImportContacts(importList, function (resp) {
        $scope.mode = 'list';
        $scope.loadAddressBook(true);
        $scope.importList = [];
        cb();
      }, function (err) {
        $scope.alertService.presentAutoAlert('importContacts', err);
      });
    }


  })



// WEBPACK FOOTER //
// ./src/controllers/modals/importContactsModalController.js